import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUniDirectionalArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33398 8H12.6673M3.33398 8L7.33398 4M3.33398 8L7.33398 12",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUniDirectionalArrowLeft;
